export default {
    MUTATION_FORM_TREE_DATA(state, visable) {
        state.mutationFormTreeData = visable;
    },
    MUTATION_V_LOADING(state, visable) {
        state.VLoading.loading = visable;
    },
    SET_USER(state,user)
    {
        //permission 为传入的权限标识集合
        // 传入的权限集合 赋值给状态中的 permission
        state.user = user;
    },
    SET_PERMISSIONKEY(state,permissionKey)
    {
        //permission 为传入的权限标识集合
        // 传入的权限集合 赋值给状态中的 permission
        state.permissionKey = permissionKey;
    }

}


// WEBPACK FOOTER //
// ./src/store/mutation.js